/*!
 * Name: jQuery ASSSS v3.2.0
 * Desc: 'A'yhan 'S'ahin 'S'uper 'S'exy 'S'earch
 * Author: Werner Hartnagel/WH
 * Author: Ayhan Sahin/AS
 * Author: Sergej Kutschin/SK
 * Author: Kilian Seizinger/KS
 * Author: Dennis Thanner/DT
 * Date: 02.03.2016
 *
 * Copyright 2014-2016 Fabrique D'Images ebusiness GmbH (http://www.fdi.de)
 */
/*
 * ChangeLog:
 * 1.0.0     Initial Release
 * 2.0.0     Many new features
 * 2.0.1     Typeahead Bugfixes
 * 2.0.2     ASS kickin' more link
 * 2.0.3     Skip Media, Department and Teaser Option
 * 2.0.5     Fix XSS Bug
 * 2.0.6     Added some options (search_headline, search_headline_template, show/hide elements)
 * 3.0.0     - Hashtag-Mode: Hashtag with given Prefix triggers Search
 *           - Supports Search in Bootstrap-Modal-Window
 * 3.1.0     - Implemeted Build-Process with Gulp.js (many THANKS to KS!!!)
 *           - awesome_spinner also takes an #search_spinner from the template instead of including an own one
 * 3.2.0     jQuery UI Autocomplete for typeahead
 * 3.2.1     Added support to open new page to display the search results, updated search logging function
 */
var ASSSSClass = function(element, options) {
	'use strict';
	var elem = $(element),
		obj = this,
		result_data = '';
	// Merge options with defaults
	obj.settings = $.extend({
		currlang: 'DE',
		dbpfad: '/fdi/web.nsf/',
		protokolldb: '/fdi/statistiken.nsf/',
		gobutton: '#searchgo',
		searchfield: '#searchfield',
		content_area: '#content',
		content_area_modal: false,
		content_area_modal_root: '#content',
		headline_area: '#content',
		search_headline: 'Suchergebnisse',
		search_headline_template: '<h1>%%HEADLINE%%</h1>',
		urlschema: '%%db%%id/%%newpageurl%%#%%hashtagval%%', // '%%db%%id/%%newpageurl%%#%%hashtagval%%'
		show_dummy_elements: '', //this elements are hidden for some issues (dummyelements 4 example)
		hide_elements: '', //this can hide some elements post-search if u need
		search_fuzzy: 1,
		char_min: 2,
		max_results: 20,
		skip_media: false,
		skip_department: false,
		skip_teaser: false,
		autoscroll: true,
		typeahead: true,
		awesome_spinner: false,
		fuzzysearch: 1,
		trigger: 'gobutton', // one of ['gobutton', 'hashtag']
		hashtag: {
			prefix: 'suche',
			separator: '~'
		},
		prev_button_text: 'Die vorherigen Ergebnisse anzeigen',
		next_button_text: 'Die n&auml;chsten Ergebnisse anzeigen',
		ajax_cb: function() {
			ajaxsearch_cb();
		},
		display_cb: function(data) {
			displayresult_tab_cb(data);
		},
		typeahead_cb: function() {
			typeahead_cb();
		},
		display_ta_cb: function(data) {
			if (jquery_ui_defined()) {
				display_jquery_ui_ta_cb(data);
			} else {
				display_ta_cb(data);
			}
		},
		debug: false
	}, options || {});
	var gobutton = elem.find(obj.settings.gobutton).css('cursor', 'pointer');
	var searchfield = elem.find(obj.settings.searchfield);
	var tmp_headline = "";
	var allowed_triggers = ['gobutton', 'hashtag'];
	var trigger = allowed_triggers[0];
	//Polyfill new Event https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
	if ($.browser.msie) {
		(function() {
			function CustomEvent(event, params) {
				params = params || {
					bubbles: false,
					cancelable: false,
					detail: undefined
				};
				var evt = document.createEvent('CustomEvent');
				evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
				return evt;
			}
			CustomEvent.prototype = window.Event.prototype;
			window.CustomEvent = CustomEvent;
		})();
		var searchGoEvent = new CustomEvent('searchgo');
	} else {
		var searchGoEvent = new Event('searchgo');
	}
	//init jquerui autocomplete
	if (jquery_ui_defined()) {
		searchfield.autocomplete({
			source: function(request, response) {
				response(result_data.data);
			},
			minLength: 2,
			focus: function(event, ui) {
				var decoded = $("<div/>").html(ui.item.bezeichnung).text();
				searchfield.val(decoded);
				return false;
			},
			select: function(event, ui) {
				var decoded = $("<div/>").html(ui.item.bezeichnung).text();
				searchfield.val(decoded);
				gobutton.trigger('click');
				return false;
			}
		}).autocomplete("instance")._renderItem = function(ul, item) {
			ul.attr('id', 'ta');
			return $("<li>")
				.append(item.bezeichnung)
				.append('<span class="pull-xs-right">' + item.score + '</span>')
				.appendTo(ul);
		};
	}
	obj.searchfield_safe = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
	if ($.inArray(obj.settings.trigger, allowed_triggers)) {
		trigger = obj.settings.trigger;
	}
	if (obj.settings.debug) {
		console.info('Starting ASSSS in ' + trigger + '-Mode!');
		console.log('loaded this settings:');
		console.log(obj.settings);
	}
	if (trigger !== 'gobutton' && trigger !== 'hashtag') {
		if (obj.settings.debug) {
			console.error('The setting "trigger" must be one of ["gobutton", "hashtag"]');
		}
		return;
	}
	if (obj.settings.awesome_spinner) {
		var search_spinner = $('#search_spinner');
		if (search_spinner.length) {
			search_spinner.hide();
			if (obj.settings.debug) {
				console.log('Found existing #search_spinner, will use it as "awesome_spinner"');
			}
		} else {
			search_spinner = $('<i id="search_spinner" class="fa fa-refresh fa-spin"></i>');
			search_spinner.hide().prependTo(elem);
			if (obj.settings.debug) {
				console.log('No #search_spinner found, added new one to the search-container');
			}
		}
	}
	if (obj.settings.typeahead && !jquery_ui_defined()) {
		// Initzialize TA Markup ...
		elem.append('<div id="ta"><div id="ta_pointer"></div><div id="ta_content"></div></div>');
		var layerTA = $("#ta");
		var layerTAContent = $("#ta_content");
		// Typeahead doesnt work with autocomplete!
		searchfield.prop('autocomplete', 'off');
		// Hide Typeahead on Background Click.....
		$('html').click(function() {
			$('#ta').hide();
		});
	}
	/* --- Define Event Handlers --- */
	elem.on('click', obj.settings.gobutton, function(e) {
		e.preventDefault();
		if (searchfield.val().length >= obj.settings.char_min) {
			if (obj.settings.awesome_spinner) {
				search_spinner.fadeIn();
			}
			if (obj.settings.typeahead && !jquery_ui_defined()) {
				layerTA.fadeOut();
			}
			if (trigger === 'gobutton') {
				if (obj.settings.newpageurl != "" & obj.settings.newpageurl != vConfig.currPageURL) {
					window.location.href = vConfig.db + 'id/' + obj.settings.newpageurl + '#' + obj.settings.hashtag.prefix + obj.settings.hashtag.separator + searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
				} else if (typeof obj.settings.ajax_cb === 'function') {
					obj.settings.ajax_cb.call(this);
				} else if (obj.settings.debug) {
					console.warn('No valid AJAX Callback function!');
				}
			} else if (trigger === 'hashtag') {
				var oldHash = window.location.hash;
				var newHash = obj.settings.hashtag.prefix + obj.settings.hashtag.separator + searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
				if (obj.settings.newpageurl != "" & obj.settings.newpageurl != vConfig.currPageURL) {
					var url = obj.settings.urlschema.replace(/%%db%%/gi, vConfig.db).replace(/%%newpageurl%%/gi, obj.settings.newpageurl).replace(/%%hashtagval%%/gi, newHash);
					window.location.href = url;
				} else if (oldHash === newHash) {
					start_hashtag_search();
				} else {
					window.location.hash = newHash;
				}
			}
		} else if (obj.settings.debug) {
			console.warn('Mindestens ' + obj.settings.char_min + ' Buchstaben eingeben! Eingabe: "' + searchfield.val().replace(/<(?:.|\n)*?>/gm, '') + '"');
		}
	});
	// Start search with Enter
	elem.on('keyup', obj.settings.searchfield, function(e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			gobutton.trigger('click');
		} else {
			if (obj.settings.typeahead && typeof obj.settings.typeahead_cb === 'function') {
				if (searchfield.val().length >= obj.settings.char_min) {
					obj.settings.typeahead_cb.call(this);
				} else {
					if (!jquery_ui_defined) {
						layerTA.fadeOut();
					}
					if (obj.settings.debug) {
						console.info('TypeAhead suche startet ab ' + obj.settings.char_min + ' Zeichen! Eingabe: "' + searchfield.val().replace(/<(?:.|\n)*?>/gm, '') + '"');
					}
				}
			} else if (obj.settings.typeahead && obj.settings.debug) {
				console.warn('No valid TypeAhead Callback function!');
			}
		}
	});
	// Display AJAX Results Callback - Private method
	var displayresult_list_cb = function(data) {
		var i = 0,
			counter = 0;
		var tmp = "";
		var orgValue = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
		var standOutStr = '';
		if (obj.settings.debug) {
			console.log("Ergebnisse: " + data.data.length);
		}
		// *** Ausgabedefinition ***
		tmp += '<ol id="sucherg_all" start="1">';
		var amount_results = data.data.length - 1;
		var hide_result, d;
		for (i = amount_results; i >= 0; i--) {
			d = data.data[i];
			//    Early break if empty
			if (d.bezeichnung === "") {
				continue;
			}
			// *** Ergebnisse ab xx Treffern verstecken ***
			hide_result = ((typeof obj.settings.max_results === "number" && obj.settings.max_results <= counter) ? true : false);
			if (d.typ === "content" || d.typ === "listen") {
				tmp += "<li" + (hide_result ? ' style="display:none;"' : '') + ">" +
					"<a href='" + d.url + "?Open&highlight=" + orgValue + "' target='_blank'>" + d.bezeichnung + " <span class='score'>(" + d.score + "%)</span></a>";
				if (!obj.settings.skip_department && d.l1.match(/\S/)) {
					tmp += "<h3 class='subHead2'>Bereich: " + d.l1 + "</h3>";
				}
				if (!obj.settings.skip_teaser && d.teaser.match(/\S/)) {
					tmp += "<div class='teaser'>" + d.teaser + "</div>";
				}
				tmp += "</li>";
				/*if(d.teaser !== " ") {
					tmp += "<span class='subDate' colspan=\"2\">" + d.modified.substr(0, 10) + "</span>";
				}*/
				counter++;
			}
		}
		tmp += "</ol>";
		//Update Typeahead Statistik
		if (obj.settings.typeahead) {
			logSearchQuery(orgValue, counter);
		}
		// *** Gesamtausgabe "Statistiksuche" u. "Standardsuche" ***
		if ($(obj.settings.headline_area).length > 0) {
			$(obj.settings.headline_area).html(obj.settings.search_headline);
		} else {
			tmp_headline = obj.settings.search_headline_template.replace(/%%HEADLINE%%/gi, obj.settings.search_headline);
		}
		if (hide_result) {
			$(obj.settings.content_area).html(
				tmp_headline + "<div><p>Zu Ihrer Suche nach '<strong>" + data.key + "</strong>'  wurden " + counter + " Ergebnisse gefunden.</p>" +
				"<div id='suche_statistiken'><div class=\"suchergebnisse\">" +
				tmp + "</div></div>" +
				"<div id='suche_volltext'><div class=\"suchergebnisse\">" + standOutStr +
				"</div></div><div id='showMoreResults' class=''></div></div>"
			);
			var less_ln = $('<a href="#" id="showPreviousResults" class="btn button">' + obj.settings.prev_button_text + '</a>');
			var more_ln = $('<a href="#" id="showNextResults" class="btn button">' + obj.settings.next_button_text + '</a>');
			var previous_next_func = function(e, type) {
				e.preventDefault();
				if (type === 'next') {
					$('#sucherg_all').attr('start', parseInt($('#sucherg_all').attr('start')) + obj.settings.max_results);
				} else if (type === 'previous') {
					$('#sucherg_all').attr('start', parseInt($('#sucherg_all').attr('start')) - obj.settings.max_results);
				}
				$('#sucherg_all li').hide();
				var actPosition = parseInt($('#sucherg_all').attr('start')) - 1;
				var objs = $('#sucherg_all li').slice(actPosition, actPosition + obj.settings.max_results);
				//console.dir(objs);
				objs.fadeIn();
				if (actPosition + obj.settings.max_results >= $('#sucherg_all li').length) {
					$('#showNextResults').hide();
				} else {
					$('#showNextResults').show();
				}
				if (actPosition <= 0) {
					$('#showPreviousResults').hide();
				} else {
					$('#showPreviousResults').show();
				}
			};
			more_ln.click(function(e) {
				previous_next_func(e, 'next');
			});
			less_ln.click(function(e) {
				previous_next_func(e, 'previous');
			});
			$('#showMoreResults').append(less_ln).append(more_ln);
			less_ln.hide();
		} else {
			$(obj.settings.content_area).html(tmp_headline + "<div><p>" +
				"Zu Ihrer Suche nach '<strong>" + data.key + "</strong>' wurden " + counter + " Ergebnisse gefunden." +
				"<div id='suche_statistiken'><div class=\"suchergebnisse\">" + tmp +
				"</div></div><div id='suche_volltext'><div class=\"suchergebnisse\">" + standOutStr +
				"</div></div></div>");
		}
		//  *** SHOW MODAL WINDOW ***
		if (obj.settings.content_area_modal) {
			$(obj.settings.content_area_modal_root).modal('show');
		}
		//    ***    SHOW DUMMY ELEMENTS    **
		if (obj.settings.show_dummy_elements !== "") {
			$(obj.settings.show_dummy_elements).show();
		}
		//    ***    HIDE ELEMENTS    **
		if (obj.settings.hide_elements !== "") {
			$(obj.settings.hide_elements).hide();
		}
		// *** Back to Top - Link ***
		if (obj.settings.autoscroll) {
			if ($(obj.settings.content_area).height() > 450) {
				$("#backToTop").show();
			}
			$('html, body').animate({
				scrollTop: $(obj.settings.content_area).offset().top
			}, 1000);
		}
	};
	// Display result as Bootstrap Tabs
	var displayresult_tab_cb = function(data) {
		var i = 0,
			counterWebseiten = 0,
			counterDownloads = 0,
			counterAdressen = 0;
		var tmp = "",
			tmpWebseiten = "",
			tmpDownloads = "",
			tmpAdressen = "";
		var orgValue = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
		var standOutStr = '';
		if (obj.settings.debug) {
			console.log("Ergebnisse: " + data.data.length);
		}
		// *** Ausgabedefinition ***
		var amount_results = data.data.length - 1;
		var d,
			hideAdresses,
			hideWebseiten,
			hideDownloads;
		for (i = amount_results; i >= 0; i--) {
			d = data.data[i];
			// Early break if empty
			if (d.bezeichnung === "") {
				continue;
			}
			if (d.docform == 'content' || d.docform == 'listen') {
				hideWebseiten = (typeof obj.settings.max_results === "number" && obj.settings.max_results <= counterWebseiten);
				tmp = "<li " + (hideWebseiten ? "style='display:none;'" : '') + " >" +
					"<a href='" + d.url + "' target='_blank'>" + d.bezeichnung + "</a>";
				tmp += "</li>";
				tmpWebseiten += tmp;
				counterWebseiten++;
			} else if (d.docform == 'dokument') {
				hideDownloads = (typeof obj.settings.max_results === "number" && obj.settings.max_results <= counterDownloads);
				tmp = "<li " + (hideDownloads ? "style='display:none;'" : '') + ">" +
					"<a href='" + d.url + "' target='_blank'>" + d.bezeichnung + "</a>";
				tmp += "</li>";
				tmpDownloads += tmp;
				counterDownloads++;
			}
		}
		/*tmp = '<ul class="search-menu nav nav-tabs m-b-2" role="tablist">';
		tmp += (counterWebseiten > 0) ? '<li class="nav-item"><a href="#search-webseiten" role="tab" data-toggle="tab" class="nav-link active">Webseiten (' + counterWebseiten + ')</a></li>' : '';
		tmp += (counterDownloads > 0) ? '<li class="nav-item"><a href="#search-downloads" role="tab" data-toggle="tab" class="nav-link ' + (counterWebseiten == 0 ? 'active' : '') + '">Downloads (' + counterDownloads + ')</a></li>' : '';
		tmp += '</ul>';*/
		tmp += '<div class="tab-content">';
		tmp += '	<div role="tabpanel" id="search-webseiten" class="tab-pane fade ' + (counterWebseiten > 0 ? 'in active' : '') + '">';
		tmp += '		<ol id="result-webseiten" class="result-list" data-start="' + obj.settings.max_results + '">' + tmpWebseiten + '</ol>';
		tmp += hideWebseiten ? '<a class="show-more-results btn btn-primary" data-toggleelement="result-webseiten">Die n&auml;chsten ' + obj.settings.max_results + ' Ergebnisse anzeigen</a>' : '';
		tmp += '	</div>';
		tmp += '	<div role="tabpanel" id="search-downloads" class="tab-pane fade ' + (counterWebseiten == 0 && counterDownloads != 0 ? 'in active' : '') + '">';
		tmp += '		<ol id="result-downloads" class="result-list" data-start="' + obj.settings.max_results + '">' + tmpDownloads + '</ol>';
		tmp += hideDownloads ? '<a class="show-more-results btn btn-primary" data-toggleelement="result-downloads">Die n&auml;chsten ' + obj.settings.max_results + ' Ergebnisse anzeigen</a>' : '';
		tmp += '	</div>';
		tmp += '</div>';
		$(document).on('click', '.show-more-results', function(e) {
			e.preventDefault();
			var toggleelem = $('#' + $(this).data('toggleelement'));
			var num_elements_to_show = toggleelem.data('start') + obj.settings.max_results;
			toggleelem.children().each(function(index) {
				if (index < num_elements_to_show) {
					$(this).show();
				}
			});
			toggleelem.data('start', num_elements_to_show);
			if (num_elements_to_show >= toggleelem.children().length) {
				$(this).hide();
			}
		});
		//UpdatesTypeahead Statistik
		var counter = counterAdressen + counterDownloads + counterWebseiten;
		if (obj.settings.typeahead) {
			logSearchQuery(orgValue, counter);
		}
		// *** Gesamtausgabe "Statistiksuche" u. "Standardsuche" ***
		if ($(obj.settings.headline_area).length > 0) {
			$(obj.settings.headline_area).html(obj.settings.search_headline);
		} else {
			tmp_headline = obj.settings.search_headline_template.replace(/%%HEADLINE%%/gi, obj.settings.search_headline);
		}
		// Ausgabe
		$(obj.settings.content_area).html(tmp_headline + "<div><p>" +
			"Zu Ihrer Suche nach '<strong>" + data.key + "</strong>' wurden " + (counter) + " Ergebnisse gefunden." +
			"<div id='suche_statistiken'><div class=\"suchergebnisse\">" + tmp +
			"</div></div><div id='suche_volltext'><div class=\"suchergebnisse\">" + standOutStr +
			"</div></div></div>");
		//  *** SHOW MODAL WINDOW ***
		if (obj.settings.content_area_modal) {
			$(obj.settings.content_area_modal_root).modal('show');
		}
		//    ***    SHOW DUMMY ELEMENTS    **
		if (obj.settings.show_dummy_elements !== "") {
			$(obj.settings.show_dummy_elements).show();
		}
		//    ***    HIDE ELEMENTS    **
		if (obj.settings.hide_elements !== "") {
			$(obj.settings.hide_elements).hide();
		}
		// *** Back to Top - Link ***
		if (obj.settings.autoscroll) {
			if ($(obj.settings.content_area).height() > 450) {
				$("#backToTop").show();
			}
			$('html, body').animate({
				scrollTop: $(obj.settings.content_area).offset().top
			}, 1000);
		}
	};
	// Fill the var for the jQuery UI autocomplete
	var display_jquery_ui_ta_cb = function(data) {
		result_data = data;
	};
	// Display Typeahead Results - Private method
	var display_ta_cb = function(data) {
		var tmp = $('<table class=""><tbody></tbody></table>');
		layerTAContent.html(tmp);
		layerTA.fadeIn('fast');
		$(data.data).each(
			function(index) {
				var d = data.data[index];
				if (d.bezeichnung === "") {
					return;
				}
				row = $("<tr>");
				cell1 = $("<td>");
				ln = $('<a href="#">' + d.bezeichnung + '</a>');
				ln.click(function(e) {
					e.preventDefault();
					searchfield.val($(this).text());
					gobutton.trigger('click');
				});
				cell1.append(ln);
				cell2 = $("<td>" + d.score + "</td>");
				row.append(cell1).append(cell2);
				layerTAContent.find('tbody').append(row);
			}
		);
	};
	// AJAX Typeahead callback - Private method
	var typeahead_cb = function() {
		var theValue = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
		var protokollSuchTA = obj.settings.protokolldb + "web_suche_typeahead";
		var protokollSuchURL = obj.settings.protokolldb + "statistiken_suche_begriffe";
		if (obj.settings.awesome_spinner) {
			search_spinner.fadeIn();
		}
		$.ajax({
				url: protokollSuchTA,
				dataType: 'text', // Should be 'json' if the Webserver sent correct MIME Typ
				data: 'OpenAgent&sprache=' + obj.settings.currlang + '&query=' + theValue + '&ns=0&rnd=' + Math.random(),
				async: true
			})
			.done(function(response) {
				response = eval("(" + response + ")");
				if (response.data.length < 1) {
					$('#ta').fadeOut();
					return true;
				} else if (!$('#ta').is(":visible")) {
					$('#ta').fadeIn();
				}
				if (typeof obj.settings.display_ta_cb === 'function') {
					obj.settings.display_ta_cb.call(this, response);
				} else if (obj.settings.debug) {
					console.warn('No valid AJAX Callback function!');
				}
			})
			.fail(function(response) {
				obj.settings.debug && console.warn("ERROR IN REQUEST\n" + response.responseText);
			})
			.always(function(response) {
				if (obj.settings.awesome_spinner) {
					search_spinner.fadeOut('Slow');
				}
			});
	};
	var typeahead_mock_cb = function() {
		var theValue = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
		var response = {
			"key": "ve",
			"data": [{
				"bezeichnung": "verm",
				"score": "137"
			}, {
				"bezeichnung": "verm&#246;g",
				"score": "63"
			}, {
				"bezeichnung": "verm&#246;gen",
				"score": "13"
			}]
		};
		response.key = theValue;
		obj.settings.display_ta_cb.call(this, response);
	};
	// AJAX Search Request - Private method
	var ajaxsearch_cb = function() {
		var orgValue = searchfield.val().replace(/<(?:.|\n)*?>/gm, '');
		var protokollSuchURL = obj.settings.protokolldb + "statistiken_suche_begriffe";
		var vCMSSuchURL = obj.settings.dbpfad + "web_suche_ft_ajax";
		var cat = '',
			subcat = '',
			datefrom = '',
			dateto = '';
		// Volltextsuche auf die voila Instanz
		$.ajax({
				url: vCMSSuchURL,
				dataType: 'text', // Should be 'json' if the Webserver sent correct MIME Typ
				data: 'OpenAgent&sprache=' + obj.settings.currlang + '&oua=0&query=' + orgValue + '&ns=0&scat=' + cat + '&ssubcat=' + subcat + '&sfromdate=' + datefrom + '&stilldate=' + dateto + '&sort=&ftsearch=' + obj.settings.fuzzysearch + '&rnd=' + Math.random(),
				async: true
			})
			.done(function(response) {
				response = eval("(" + response + ")");
				if (typeof obj.settings.display_cb === 'function') {
					obj.settings.display_cb.call(obj, response);
				} else if (obj.settings.debug) {
					console.warn('No valid Display Callback function!');
				}
				if (obj.settings.awesome_spinner) {
					search_spinner.fadeOut('slow');
				}
			})
			.fail(function(json) {
				if (obj.settings.debug) {
					console.warn("ERROR IN REQUEST\n" + json.responseText);
				}
			});
	};
	// Handle hashtag-trigger events
	if (trigger === 'hashtag') {
		var start_hashtag_search = function() {
			var hash = window.location.hash;
			var hashParts = hash.split(obj.settings.hashtag.separator);
			if (hashParts[0].toLowerCase() === "#" + obj.settings.hashtag.prefix && typeof hashParts[1] !== 'undefined') {
				var suche = hashParts[1];
				// Decode URL-HashTag-Part
				suche = decodeURI(suche);
				if (suche.length > 0) {
					searchfield.val(suche);
					if (typeof obj.settings.ajax_cb === 'function') {
						obj.settings.ajax_cb.call(this);
					} else if (obj.settings.debug) {
						console.warn('No valid AJAX Callback function!');
					}
				} else if (obj.settings.debug) {
					console.info('No search-String given!');
				}
			} else if (obj.settings.debug) {
				console.warn('Hash "' + hash + '" doesn\'t start with "#' + obj.settings.hashtag.prefix + obj.settings.hashtag.separator + '"!');
			}
		};
		if (window.location.hash.length > 0) {
			start_hashtag_search();
		}
		$(window).bind('hashchange', function(e) {
			start_hashtag_search();
		});
		if (obj.settings.content_area_modal) {
			$(obj.settings.content_area_modal_root).on('hidden.bs.modal', function() {
				window.location.hash = '#';
			});
		}
	}
	/*    Alle Suchanfragen, die Ergebnisse liefern (z. Zt. > 1, da vCMS ein Fake-Ergebnis zur Suchanfrage hinzufügt),
	werden protokolliert (für die Type-Ahead-Funktion) */
	function logSearchQuery(theValue, theCount) {
		var logsearchimg = obj.settings.protokolldb + "suchvorgang.gif?OpenForm&sprache=" + obj.settings.currlang + "&begriff=" + theValue.replace(/<(?:.|\n)*?>/gm, '') + "&score=" + theCount;
		if (theCount > 1) {
			if ($('logsearchimg').length > 0) {
				$('logsearchimg').prop('src', logsearchimg);
			} else {
				$(document.body).append("<img id=\"logsearchquery\" style=\"display:none;\" src=\"" + logsearchimg + "\" width=\"1\" height=\"1\">");
			}
		}
	};
};
/* ============= MAIN ASSSS ============= */
$.fn.assss = function(options) {
	// if nothing is selected, return nothing; can't chain anyway
	if (!this.length) {
		if (options && options.debug && window.console) {
			console.warn("no objects found, returning nothing.");
		}
		return;
	}
	return this.each(function() {
		var element = $(this);
		// Return early if this element already has a plugin instance
		if (element.data('assss')) {
			return;
		}
		var assss = new ASSSSClass(this, options);
		// Store plugin object in this element's data
		element.data('assss', assss);
	});
}

function jquery_ui_defined() {
	return typeof jQuery.ui == "object";
}